import { CoinSponsorStatus, XyoWorldGeotokenSettingsClient } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

interface GeotokensSettingsContext {
  filter?: CoinSponsorStatus
  refresh?: () => void
  settingsList?: XyoWorldGeotokenSettingsClient[] | undefined
  updateFilter?: (filter?: CoinSponsorStatus) => void
}

const Context = createContext<GeotokensSettingsContext>({})

export default Context
